import React from "react";
import "../styles/Projects.css";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";
import FadeInSection from "./FadeInSection";
import ExternalLinks from "./ExternalLinks";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const projects = {
      "Your Royal Dock": {
        desc:
          "Your Royal Dock is a on going project currently being developed to increase community egagement and tourism in the Royal Docks area in London.",
        techStack: "React.js, CSS/Bootstrap, Node.js (Express)",
        link: "https://github.com/Manjellion/YRD-UI",
        open: "https://your-royaldocks.netlify.app/"
      },
      "My Taxi (AWS)": {
        desc:
          "A cross-platform Taxi mobile application developed with a serverless appraoch using cloud computing.",
        techStack: "React-native, JavaScript, AWS Amplify",
        link: "https://github.com/Manjellion/AWSAmplify-taxiApp",
      },
      "Car Park Application System": {
        desc:
          "Car park GUI application developed using advanced Java techniques etc: File handling, Lambda expressions, class collection and Exceptions.",
        techStack: "Java, JavaFX, JUnit",
        link: "https://github.com/Manjellion/CarSystem-GUI",
      },
      "Covid Tracker": {
        desc:
          "Following the MERN stack and CRUD operation we developed a web application to track users registered and show if they are infected or not.",
        techStack: "React.js, Node.js (Express), MongoDB (Mongoose)",
        link:
          "https://github.com/Manjellion/CW-covid-Tracker-webApp-uni"
      },
      "Favour Meal": {
        desc:
          "A website that uses the Recipe API to display 1000's of recipes upon searching while allowing users to add their facourite food",
        techStack: "HTML5, CSS3, JavaScript E6",
        link: "https://github.com/Manjellion/recipeApp",
        open: "https://favourmeals.netlify.app/"
      },
      "Pedal co.": {
        desc:
          "A bicycle rental website",
        techStack: "HTML, CSS, JS",
        link: "https://github.com/Manjellion/Pedal-co",
        open: "https://pedal-manjil.netlify.app/"
      }
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">/ projects</span>
        </div>
        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <FadeInSection delay={`${i + 1}00ms`}>
                <li className="projects-card">
                  <div className="card-header">
                    <div className="folder-icon">
                      <FolderOpenRoundedIcon
                        style={{ fontSize: 35 }}
                      ></FolderOpenRoundedIcon>
                    </div>
                    <ExternalLinks
                      githubLink={projects[key]["link"]}
                      openLink={projects[key]["open"]}
                    ></ExternalLinks>
                  </div>
                  <div className="card-title">{key}</div>
                  <div className="card-desc">{projects[key]["desc"]}</div>
                  <div className="card-tech">{projects[key]["techStack"]}</div>
                </li>
              </FadeInSection>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Projects;
